import React from "react";

const CustomLoader = () => {
	return (
		<div className="dashboard-page">
			<div className="loading-container">
				<div className="spinner-large"></div>
				<h3>Loading...</h3>
				<p>Please wait while we fetch your data.</p>
			</div>
		</div>
	);
};

export default CustomLoader;
